//-------------------------------------------
//onload
//-------------------------------------------
window.addEventListener('load', (e) => { 
  const atcForm = document.querySelector("[data-product-form]")
  atcForm?.addEventListener('submit', () => {
    addProductToCart()
  })
})

function addProductToCart(e) {
  const thisProduct = dataLayerData.product
  const quantity = document.querySelector("[data-quantity-select]")?.value
  thisProduct.quantity = parseInt(quantity)
  window.dataLayer.push({
    event: "ecomAdd",
    ecommerce: {
      currencyCode: "USD",
      add: {
        products: [thisProduct],
      },
    },
  });
}